export const getRandomNumber = () => {
	let generatedUniqueNumber = Math.random().toFixed(3);
	return generatedUniqueNumber;
};
